/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import { gql } from '@apollo/client'

export const GET_ACTION_GROUPS = gql`
  query GetTenantActionGroups {
    tenantActionGroups {
      title
      id
    }
  }
`
